import PropTypes from 'prop-types';
import React from 'react';

import Confirm from 'common/components/Confirm';
import messages from 'ondemand/messages.json';

const RideCancelModal = ({needsApproval, paid, ...rest}) => (
  <Confirm
    cancelButtonDataId={'cancel-button'}
    confirmButtonDataId={'confirm-cancel-button'}
    confirmButtonText="Yes"
    cancelButtonText="No"
    message={
      <div>
        {paid && <i>{messages.cancelPaid} </i>}
        {(needsApproval && messages.cancelNeedsApproval) || messages.cancelGeneric}
        <br /><br />
        <div>Are you sure you want to cancel?</div>
      </div>
    }
    messageDataId={'cancel-ride-message'}
    modalDataId={'cancel-ride-modal-container'}
    title="Confirm Cancel"
    {...rest}
  />
);

RideCancelModal.propTypes = {
  needsApproval: PropTypes.bool,
  paid: PropTypes.bool,
};

export default RideCancelModal;



// WEBPACK FOOTER //
// ./src/ondemand/components/RideCancelModal.js